// store/thunks/auth/sendEmailCodeThunk.ts

import { createAdminAsyncThunk } from "@/store/thunks/createAdminAsyncThunk";
import { VerificationDTO } from "@/types/dtos.types";

export const sendEmailCodeThunk = createAdminAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/sendEmailCode',
  async(_, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendEmailCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send email code';
      return rejectWithValue({ message });
    }
  }
);
